import { _ as _extends } from '../../_rollupPluginBabelHelpers-c245b26a.js';
import { forwardRef } from 'react';
import { themed, getDefaultThemedOptions } from '@indeed/ifl-css';
import { useDialogContext } from './context.js';
import { jsx } from '@emotion/react';
import '@indeed/ihl-use-id';
import '../../hooks/useControllableState.js';
import '../../utils/warn.js';
import '../../hooks/useIsMobile.js';
import '../../hooks/useWindowSize.js';
import '../../hooks/useIsomorphicLayoutEffect.js';
import '../../hooks/useResponsiveValue.js';
import '../../hooks/useBreakpointIndex.js';

const baseStyles = _ref => {
  let {
    type
  } = _ref;
  return {
    alignItems: "center",
    borderTopWidth: type === "popup" ? 0 : "1px",
    borderTopStyle: "solid",
    borderColor: "border.weak",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "row",
    inlineSize: "100%",
    justifyContent: "flex-end",
    paddingBlockEnd: ["3", "4"],
    paddingBlockStart: type === "popup" ? 0 : ["3", "4"],
    paddingInlineEnd: type === "popup" ? 5 : ["3", "4"],
    paddingInlineStart: ["3", "4"],
    position: "relative"
  };
};
const StyledDialogFooter = /*#__PURE__*/themed("div", process.env.NODE_ENV === "production" ? _extends({}, {
  target: "ekmvxbp0"
}, getDefaultThemedOptions("type")) : _extends({}, {
  target: "ekmvxbp0",
  label: "StyledDialogFooter"
}, getDefaultThemedOptions("type")))(baseStyles, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
const DialogFooter = /*#__PURE__*/forwardRef((_ref2, forwardedRef) => {
  let {
    children,
    ...remainingProps
  } = _ref2;
  const {
    type
  } = useDialogContext();
  return jsx(StyledDialogFooter, _extends({
    ref: forwardedRef,
    type: type
  }, remainingProps), children);
});
DialogFooter.displayName = "DialogFooter";

export { DialogFooter, StyledDialogFooter, baseStyles };
